export default __webpack_public_path__ + "e95d9ae6b34472eaf507eb8b5dc3eefc.svg";